export const FETCH_VESSELS_SUCCESS = "Get Vessels success"
export const FETCH_VESSELS_FAILURE = "Get Vessels failure"
export const FETCH_VESSELS = "Fetch vessels by shipmanager"

export const FETCH_VESSEL_DETAIL_BY_ID = "Fetch Vessel detail"
export const FETCH_VESSEL_DETAIL_BY_ID_SUCCESS = "Fetch Vessel detail success"
export const FETCH_VESSEL_DETAIL_BY_ID_FAILURE = "Fetch Vessel detail failure"

export const FETCH_VESSSEL_TRACKING_SUCCESS = "Fetch Vessel tracking success"
export const FETCH_VESSSEL_TRACKING_FAILURE = "Fetch Vessel tracking failure"

export const FETCH_MASTER_DATA_SUCCESS = "Fetch Vessel master data success"
export const FETCH_MASTER_DATA_FAILURE = "Fetch Vessel master data failure"

export const FETCH_VESSEL_VISITS_DATA_SUCCESS = "Fetch Vessel visits data success"
export const FETCH_SHIPYARD_VISITS_DATA_SUCCESS = "Fetch Shipyard visits data success"
export const FETCH_VISITS_DATA_FAILURE = "Fetch Vessel visits data failure"


export const GET_ROUTE_TO_COMPANY = "get route to company"
export const GET_ROUTE_TO_COMPANY_SUCCESS = "get route to company success"
export const GET_ROUTE_TO_COMPANY_FAILURE = "get route to company failure"


export const fetchFleetProductVessels = (companyId) => ({
  type: FETCH_VESSELS,
  companyId: companyId
});

export const fetchVesselDetailById = (data) => ({
  type: FETCH_VESSEL_DETAIL_BY_ID,
  payload: data
})